import { Component, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { AssignActivitiesProjectsService } from '../../../survey-insight/survey-creation/assign-activities-projects/assign-activities-projects.service';
import { SessionService } from '../../session-service/session.service';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { BaseResponse } from '../../models/base-response.model';
import { ActivityTypeEnum } from 'src/app/shared/constants/activity-type.enum';
import { Messages } from '../../constants/messages';
import { EngagementGroupActivity, SurveyPrepDataEntity } from '../../models/Survey-Creation/SurveyCreation.model';
import { Router } from '@angular/router';
import { ROUTE_URL } from '../../constants/route-constants';
import { SurveyListService } from 'src/app/survey-insight/survey-list/survey-list.service';

@Component({
  selector: 'aa-add-activities',
  templateUrl: './add-activities-component.html',
  styleUrls: ['./add-activities-component.scss']
})
export class AddActivitiesComponent implements OnInit, OnDestroy, DoCheck {
  activities: EngagementGroupActivity[] = [];
  rowData: SurveyPrepDataEntity[] = [];
  selectedActivities: EngagementGroupActivity[] = [];
  masterData: any;
  masterPropertyName: string;
  selectAll = false;
  targetFormSubmitted: boolean;
  engagementId: string;
  allGroupValue: string = null;
  isAddDisabled = false;
  drawName: string = '';
  constructor(private _surveyListService: SurveyListService,
    public rightSideDrawerService: RightSideDrawerService,
    public sessionService: SessionService,
    public _assignActivitiesProjectsService: AssignActivitiesProjectsService,
    public toastrService: ToastrService,
    private _loader: LoadingIndicatorService, private _router: Router) {
    this.engagementId = this.sessionService.getSession('engagementId');
  }

  ngOnInit() {
    this.masterData = this.rightSideDrawerService.singleRowEditData;
    this.rowData = this.masterData.rowData;
    this.masterPropertyName = this.getPropertyNameByActivityType(this.masterData.activityType);
    let groupValueTitle: string;
    this.rowData.forEach((x: SurveyPrepDataEntity) => {
      groupValueTitle = groupValueTitle ? groupValueTitle + ', '
        : (x.adHocName) ? x.adHocName + ', '
          : (x.companyName) ? x.companyName + ', '
            : (x.costCenterDescName) ? x.costCenterDescName + ', '
              : (x.individualName) ? x.individualName + ', '
                : (x.locationName) ? x.locationName + ', '
                  : (x.smeName) ? x.smeName + ', '
                    : (x.timeTrackingDataName) ? x.timeTrackingDataName + ', '
                      : (x.titleName) ? x.titleName + ', ' : ''
    });
    this.allGroupValue = groupValueTitle;
    this.getActivityList();
    this.GetDrawName();
  }

  private getPropertyNameByActivityType(activityType: number): string {
    switch (activityType) {
      case ActivityTypeEnum.Activity:
        return 'activities'
      case ActivityTypeEnum.NQA:
        return 'nqas'
      case ActivityTypeEnum.NWT:
        return 'nwts'
    }
  }

  ngDoCheck() {
    if (!this.isAddDisabled) {
      this.rightSideDrawerService.setMandatoryField(
        true,
        'Assign Activities for ' + this.drawName
      );
    } else {
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
  }

  ngOnDestroy() {
    this.rightSideDrawerService.closeRightSideDrawer();
  }

  navigateToProjectsAndActivities(): void {
    this.rightSideDrawerService.closeRightSideDrawer();
    this._router.navigate([ROUTE_URL.MANAGE_PROJECT(this.engagementId)]);
  }

  GetDrawName() {
    let drawName = '';
    if (this.rowData[0].adHocName) { drawName = drawName + this.rowData[0].adHocName + ', '; }
    if (this.rowData[0].companyName) { drawName = drawName + this.rowData[0].companyName + ', '; }
    if (this.rowData[0].costCenterDescName) { drawName = drawName + this.rowData[0].costCenterDescName + ', '; }
    if (this.rowData[0].individualName) { drawName = drawName + this.rowData[0].individualName + ', '; }
    if (this.rowData[0].locationName) { drawName = drawName + this.rowData[0].locationName + ', '; }
    if (this.rowData[0].smeName) { drawName = drawName + this.rowData[0].smeName + ', '; }
    if (this.rowData[0].timeTrackingDataName) { drawName = drawName + this.rowData[0].timeTrackingDataName + ', '; }
    if (this.rowData[0].titleName) { drawName = drawName + this.rowData[0].titleName + ', '; }
    if (this.rowData[0].taxPeriodName) { drawName = drawName + this.rowData[0].taxPeriodName + ', '; }
    if (drawName.length >= 0) {
      drawName = drawName.slice(0, -1);
    }
    this.drawName = this._surveyListService.removeUnwantedCharcterAtEnd(drawName, ',');
    let surveyName = '';
    if (this.rowData[0].adHocValue) { surveyName = surveyName + this.rowData[0].adHocValue + ', '; }
    if (this.rowData[0].companyValue) { surveyName = surveyName + this.rowData[0].companyValue + ', '; }
    if (this.rowData[0].costCenterDescValue) { surveyName = surveyName + this.rowData[0].costCenterDescValue + ', '; }
    if (this.rowData[0].individualValue) { surveyName = surveyName + this.rowData[0].individualValue + ', '; }
    if (this.rowData[0].locationValue) { surveyName = surveyName + this.rowData[0].locationValue + ', '; }
    if (this.rowData[0].smeValue) { surveyName = surveyName + this.rowData[0].smeValue + ', '; }
    if (this.rowData[0].timeTrackingDataValue) { surveyName = surveyName + this.rowData[0].timeTrackingDataValue + ', '; }
    if (this.rowData[0].titleValue) { surveyName = surveyName + this.rowData[0].titleValue + ', '; }
    if (this.rowData[0].taxPeriodValue) { surveyName = surveyName + this.rowData[0].taxPeriodValue + ', '; }
    surveyName = this._surveyListService.removeUnwantedCharcterAtEnd(surveyName.trim(), ',');
    this.drawName = this.drawName.trim() + ': ' + surveyName.trim();
  }
  getActivityList = () => {
    this._loader.display(true, true);
    this._assignActivitiesProjectsService
      .GetActivityList(this.masterData.groupId, '')
      .subscribe(
        (data: BaseResponse) => {
          if (data !== null && data.success) {
            this.activities = data.result
              .sort((a, b) => a.activityName.localeCompare(b.activityName))
              .filter(x => x.activityType === this.masterData.activityType);
              this._loader.display(false);
              if (this.rowData.length === 1 && this.rowData[0][this.masterPropertyName] !== null) {
                  this.updateActivitySelection(this.rowData[0][this.masterPropertyName], this.activities);
                } else if (this.rowData.length > 1) {
                  this.updateActivitySelectionMultiple();
                }

            this.selectedActivities = this.activities.filter(x => x.isSelected === true);
            if (this.activities.length === this.selectedActivities.length) {
              this.selectAll = true;
              this.isAddDisabled = false;
            }

          } else {
            this._loader.display(false);
            this.isAddDisabled = true;
            this.toastrService.setErrorMessage(
              Messages.SurveyCreation.AssignProjectActivities.GetActivityListFailure
            );
          }
          this._loader.display(false);
        }
      );
  };

  updateActivitySelection(selectedActivity: EngagementGroupActivity[], activityList: EngagementGroupActivity[]) {
    selectedActivity.forEach(x => {
      activityList.map(prj => {
        if (prj.activityId!=null && prj.activityId === x.activityId) {
          prj.isSelected = true;
        }
      });
    });
  }

  updateActivitySelectionMultiple() {
    const allActivity: EngagementGroupActivity[] = [];
    const rowDataCount: number = this.rowData.length;
    this.rowData.forEach(x => {
      if(x[this.masterPropertyName]!=null)
      {
        allActivity.push(...(x[this.masterPropertyName]));
      }
    });
   // this.rowData.forEach(x => allActivity.push(...(x[this.masterPropertyName])));
    this.activities.forEach(x => {
      let activityexist=allActivity.filter(x=>x.activityId!=null);
      const actCount: number = activityexist.filter(act => act.activityId === x.activityId).length;
      if (actCount === rowDataCount) {
        x.isSelected = true;
        x.indeterminate = false;
      } else if (actCount > 0 && actCount < rowDataCount) {
        x.isSelected = false;
        x.indeterminate = true;
      } else {
        x.isSelected = false;
        x.indeterminate = false;
      }
    });
  }

  submitActivities = () => {
    this.isAddDisabled = true;
    if (
      this.activities.length !== 0 &&
      this.selectedActivities.length !== 0
    ) {
      if (this.rowData.length === 1) {
        this.rowData.forEach(x => x[this.masterPropertyName] = this.selectedActivities);
      } else {
        this._loader.display(true, true);
        const indeterminateAct: EngagementGroupActivity[] = this.activities.filter(x => x.indeterminate);
        this.rowData.forEach(x => {
          let indeterminateOriginalAct: EngagementGroupActivity[] = [];
          if(x[this.masterPropertyName]!=null)
          {
          indeterminateOriginalAct = x[this.masterPropertyName];
          }
          const indeterminateCalculatedAct: EngagementGroupActivity[] = [];
          indeterminateAct.forEach(x => {
            indeterminateCalculatedAct.push(...indeterminateOriginalAct.filter(itm => itm.activityId === x.activityId));
          });
          x[this.masterPropertyName] = [];
          x[this.masterPropertyName].push(...indeterminateCalculatedAct);
          x[this.masterPropertyName].push(...this.selectedActivities);
        });

        this._loader.display(false);
      }

      this.toastrService.setSuccessMessage(
        Messages.SurveyCreation.AssignProjectActivities
          .AddActivityToTempSuccess
      );
    }
    this.rightSideDrawerService.closeRightSideDrawer();
  };

  SetActivities = (activity, event) => {
    if (event.target.checked) {
      activity.isSelected = true;
      if (this.selectedActivities.filter(x => x.activityId === activity.activityId).length === 0) {
        this.selectedActivities.push(activity);
      }
      if (this.activities.length === this.selectedActivities.length) {
        this.selectAll = true;
      }
    } else {
      this.selectAll = false;
      activity.isSelected = false;
      this.selectedActivities = [...this.selectedActivities.filter(x => x.activityId !== activity.activityId)];
    }
    activity.indeterminate = false;
    if (this.selectedActivities.length === 0) {
      this.isAddDisabled = true;
    } else {
      this.isAddDisabled = false;
    }
  };

  SelectAll = event => {
    if (event.target.checked) {
      this.selectAll = true;
      this.isAddDisabled = false;
      this.selectedActivities = [];
      this.activities.forEach((x: any) => {
        x.isSelected = true;
        x.indeterminate = false;
      });
      this.selectedActivities = this.activities;
    } else {
      this.isAddDisabled = true;
      this.activities.forEach((x: any) => {
        x.isSelected = false;
        x.indeterminate = false;
      });
      this.selectedActivities = [];
    }
  };

  public buildFrom(activity) {
    this.rightSideDrawerService.singleRowEditData = activity;
  }
}
